import type { IconData } from '@stacksjs/iconify-core'

export const informationDesk: IconData = {
  "body": "<g fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\" stroke-width=\"3\"><path d=\"M44.906 40.668c-.16-1.042-1.129-1.552-2.182-1.57C40.313 39.06 34.868 39 24 39s-16.312.06-18.723.099c-1.054.017-2.023.528-2.183 1.57A9 9 0 0 0 3 42.02c0 .526.036.965.09 1.33c.16 1.056 1.143 1.57 2.211 1.582C7.725 44.96 13.17 45 24 45s16.276-.04 18.699-.067c1.068-.012 2.051-.526 2.21-1.582c.055-.364.091-.803.091-1.33a9 9 0 0 0-.094-1.353M23 14a11 11 0 1 0 22 0a11 11 0 1 0-22 0m0 25a48 48 0 0 0-.708-4.536c-.385-1.887-1.945-3.253-3.867-3.366A58 58 0 0 0 15 31c-1.32 0-2.472.041-3.425.098c-1.922.113-3.482 1.48-3.867 3.366c-.26 1.27-.53 2.841-.708 4.536\"/><path d=\"M9 25a6 6 0 1 0 12 0a6 6 0 1 0-12 0m25-11v5m0-10v1\"/></g>",
  "width": 48,
  "height": 48,
  "viewBox": "0 0 48 48"
}

export default informationDesk
